var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomFilters = function SvgHomFilters(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.167 2.667a1.833 1.833 0 1 1-3.667 0 1.833 1.833 0 0 1 3.667 0ZM9.333 3.5a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667ZM8 9.833a1.833 1.833 0 1 1 0-3.666 1.833 1.833 0 0 1 0 3.666ZM7.167 8a.833.833 0 1 0 1.666 0 .833.833 0 0 0-1.666 0ZM6.667 15.167a1.833 1.833 0 1 1 0-3.667 1.833 1.833 0 0 1 0 3.667Zm-.834-1.834a.833.833 0 1 0 1.667 0 .833.833 0 0 0-1.667 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.167 8a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5ZM9.333 12.833a.5.5 0 0 0 0 1h3.334a.5.5 0 1 0 0-1H9.333ZM7.167 2.667a.5.5 0 0 0-.5-.5H3.333a.5.5 0 1 0 0 1h3.334a.5.5 0 0 0 .5-.5ZM3.333 7.5a.5.5 0 0 0 0 1h2a.5.5 0 1 0 0-1h-2ZM2.833 13.333a.5.5 0 0 1 .5-.5H4a.5.5 0 0 1 0 1h-.667a.5.5 0 0 1-.5-.5ZM12.667 2.167a.5.5 0 0 1 0 1H12a.5.5 0 0 1 0-1h.667Z",
    fill: "currentColor"
  })));
};
export default SvgHomFilters;